import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar/NavbarDashboard";
import {
  auth,
  registerWithEmailAndPassword,
  signInWithGoogle,
} from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import TextField from "@mui/material/TextField";
import "../styles/style.css";
import { NavLink } from "react-bootstrap";
import { FcGoogle } from "react-icons/fc";
import rs_logo_f from "../assets/images/roadsense_logo_full.png";
import rs_logo from "../assets/images/roadsense_logo.png";
import NavbarLanding from "../components/Navbar/NavbarLanding";
import "../styles/style.css";
import ImageCarousel from "../components/tips_carousel/tips_carousel";
import tip_1 from "../assets/images/tips/1.png"
import tip_2 from "../assets/images/tips/2.png"
import tip_3 from "../assets/images/tips/3.png"

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  const register = () => {
    if (!name) alert("Please enter name");
    registerWithEmailAndPassword(name, email, password);
  };
  useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
  }, [user, loading]);

  const images = [
    tip_1,
    tip_2,
    tip_3,
    // Add more image URLs as needed
  ];


  return (
    <div className="background">
      <NavbarLanding />

      <div className="index-wrapper">
        <div className="index-infobar">
          <h1>Register to Roadsense</h1>
          <p>Get started and learn. Sign up with Roadsense for free and become a driver equipped with the fundamentals.</p>
          <ImageCarousel images={images} />
        </div>

        <div className="container-index expandAnimate">
            <div className="login-header">
              <img src={rs_logo_f} style={{ height: '50px' }}></img>
              <h3>Register</h3>
            </div>
              <input
                type="text"
                placeholder="Username"
                className="login_field"
                value={name}
                onChange={(e) => setName(e.target.value)}
                inputProps={{ maxLength: 12 }}
              />
              <input
                type="email"
                placeholder="Email address"
                className="login_field"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                placeholder="Enter your password"
                className="login_field"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <button
                className="login_btn"
                onClick={register}
              >
                Register
              </button>

              <div class="line-container">
                <div class="line"></div>
                <div class="or-text">OR</div>
              </div>

              <button className="login-google" onClick={signInWithGoogle}>
                <FcGoogle style={{ fontSize: '2em' }}/>
                Create an Account with Google
              </button>
              <div className="container-create-account">
                Already have an account?{" "}
                <Link to="/" className="color--accent">Log In</Link>.
              </div>
        </div> 

      </div>


    </div>
  );
}
export default Register;
